module.exports = {"seasonal_type":{"beguiling":""}};